import Post from "../../core/classes/Post";
export default class SearchPosts {
  constructor({ count, numPages, posts } = {}) {
    this.count = count || 0;
    this.numPages = numPages || 1;
    this.posts = [];
    if (posts && Array.isArray(posts)) {
      posts.forEach(post => {
        this.posts.push(new Post(post));
      });
    }
  }
}
